import { Record as record } from 'immutable';

import trainTime from '../../lib/TrainTime';
import { getDefaults, getResolvers } from '../../helpers/Records';
import { construct, resolve } from '../../helpers/LinkMapper';

const fieldSchema = {
    "id": [ resolve.with(Number) ],
    "refundId": [ resolve.with(Number) ],
    "paymentType": [ resolve.with(String) ],
    "amount": [ resolve.with(Number) ],
    "reason": [ resolve.with(String) ],
    "created": [ resolve.with(trainTime) ],
};

export default class AlternativePayment extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(AlternativePayment, json, getResolvers(fieldSchema));
    }

    hasAmount () {
        return this.amount > 0;
    }
}
